import { createAction } from 'redux-actions';
import * as Actions from '../constants/actions';

export const checkStatus = createAction(Actions.CHECK_STATUS);
/**
 * Wizard data actions.
 */
export const fetchWizardData = createAction(Actions.FETCH_WIZARD_DATA);
export const fetchWizardDataFailure = createAction(Actions.FETCH_WIZARD_DATA_FAILURE);
export const fetchWizardDataSuccess = createAction(
	Actions.FETCH_WIZARD_DATA_SUCCESS, 
	( plugins: object, themes: object ) => { 
		return {
			plugins: plugins,
			themes: themes
		}; 
	},
);

/**
 * Steps data actions.
 */
export const fetchStepsData = createAction(Actions.FETCH_STEPS_DATA);
export const fetchStepsDataSuccess = createAction(Actions.FETCH_STEPS_DATA_SUCCESS);
export const fetchStepsDataFailure = createAction(Actions.FETCH_STEPS_DATA_FAILURE);

export const updateStatus = createAction(
	Actions.UPDATE_STATUS,
	( data: object ) => { 
		return { data: data }; 
	},
);

export const sendRequest = createAction(Actions.SEND_REQUEST);
export const sendRequestFailure = createAction(Actions.SEND_REQUEST_FAILURE);

export const StepChangeNext = createAction(Actions.STEP_CHANGE_NEXT);
export const StepChangePrev = createAction(Actions.STEP_CHANGE_PREV);


/**
 * Themes data actions.
 */
export const AddTheme = createAction(
	Actions.ADD_THEME, 
	( id: number ) => { 
		return { id: id }; 
	},
);

export const AddThemeTag = createAction(
	Actions.ADD_THEME_TAG, 
	( tag: string ) => { 
		return { tag: tag }; 
	},
);

/**
 * Plugins data actions.
 */
export const RemoveAllPlugins = createAction(Actions.REMOVE_ALL_PLUGINS);
export const RemovePlugin = createAction(
	Actions.REMOVE_PLUGIN, 
	( id: number ) => { 
		return { id: id }; 
	},
);

export const AddPlugin = createAction(
	Actions.ADD_PLUGIN, 
	( id: number ) => { 
		return { id: id }; 
	},
);


export const PreviewTheme = createAction(
	Actions.PREVIEW_THEME, 
	( id: number ) => { 
		return { id: id }; 
	},
);

export const ClosePreviewTheme = createAction(
	Actions.CLOSE_PREVIEW_THEME, 
	( id: number ) => { 
		return { id: id }; 
	},
);
export const onPageInit = createAction(Actions.PAGE_INIT);
export const onPageResize = createAction(Actions.PAGE_RESIZE);

export const sendStatistics = createAction(Actions.SEND_STATISTICS);